export default {
  path: "/app/travel-request",
  name: "travel-request",
  redirect: "/app/travel-request/my-list",
  component: () => import("./layout"),
  children: [
    {
      name: "myListTravelRequest",
      path: "/app/travel-request/my-list",
      component: () => import("./my-list.vue"),
      meta: {
        appName: "myListTravelRequest",
        detail: "detailTravelRequest",
      },
      children: [
        {
          name: "detailTravelRequest",
          path: "/app/travel-request/:id/detail",
          component: () => import("./detail-view.vue"),
          meta: {
            listName: "myListTravelRequest",
            showRight: true,
            appName: "myListTravelRequest",
            detail: "detailTravelRequest",
          },
        },
      ],
    },
    {
      name: "myListApprovalTravelRequest",
      path: "/app/travel-request/my-approval-list",
      component: () => import("./my-approval-list.vue"),
      meta: {
        appName: "myListApprovalTravelRequest",
        detail: "detailApprovalTravelRequest",
      },
      children: [
        {
          name: "detailApprovalTravelRequest",
          path: "/app/travel-request/:id/approval-detail",
          component: () => import("./detail-view.vue"),
          meta: {
            listName: "myListApprovalTravelRequest",
            showRight: true,
            appName: "myListApprovalTravelRequest",
            detail: "detailApprovalTravelRequest",
          },
        },
      ],
    },
    {
      name: "adminManagerListApprovalVehicleUsageApprovedTable",
      path: "/app/travel-request/vehicle/admin-manager-approved-table",
      component: () => import("./vehicle.admin-manager.approval-table.vue"),
      meta: {
        appName: "adminManagerTableApprovalVehicleUsage",
        detail: "detailAdminManagerTableApprovalVehicleUsage",
      },
    },
    {
      name: "myListTravelRequestCanCreateFlightInfo",
      path: "/app/travel-request/my-list-can-create-flight-info",
      component: () => import("./my-travel-request.can-create-flight-info.vue"),
      meta: {
        appName: "myListTravelRequestCanCreateFlightInfo",
        detail: "detailTravelRequestCanCreateFlightInfo",
      },
      children: [
        {
          name: "detailTravelRequestCanCreateFlightInfo",
          path: "/app/travel-request/:id/can-create-flight-info-detail",
          component: () => import("./detail-view.vue"),
          meta: {
            listName: "myListTravelRequestCanCreateFlightInfo",
            showRight: true,
            appName: "myListTravelRequestCanCreateFlightInfo",
            detail: "detailTravelRequestCanCreateFlightInfo",
          },
        },
      ],
    },

    // FOR HR
    {
      name: "myListTravelRequestHRCanEdit",
      path: "/app/travel-request/hr-can-edit",
      component: () => import("./my-travel-request.hr-can-edit.vue"),
      meta: {
        appName: "myListTravelRequestHRCanEdit",
        detail: "detailTravelRequestHRCanEdit",
      },
      children: [
        {
          name: "detailTravelRequestHRCanEdit",
          path: "/app/travel-request/:id/hr-can-edit-detail",
          component: () => import("./detail-view.vue"),
          meta: {
            listName: "myListTravelRequestHRCanEdit",
            showRight: true,
            appName: "myListTravelRequestHRCanEdit",
            detail: "detailTravelRequestHRCanEdit",
          },
        },
      ],
    },
    // FOR DM
    {
      name: "myListTravelRequestManagerCanEdit",
      path: "/app/travel-request/manager-can-edit",
      component: () => import("./my-travel-request.manager-can-edit.vue"),
      meta: {
        appName: "myListTravelRequestManagerCanEdit",
        detail: "detailTravelRequestManagerCanEdit",
      },
      children: [
        {
          name: "detailTravelRequestManagerCanEdit",
          path: "/app/travel-request/:id/manager-can-edit-detail",
          component: () => import("./detail-view.vue"),
          meta: {
            listName: "myListTravelRequestManagerCanEdit",
            showRight: true,
            appName: "myListTravelRequestManagerCanEdit",
            detail: "detailTravelRequestManagerCanEdit",
          },
        },
      ],
    },
    // EDIT
    {
      name: "travelRequestEditList",
      path: "/app/travel-request/edit-list",
      component: () => import("./my-travel-request-edit.list"),
      meta: {
        appName: "travelRequestEditList",
        detail: "detailTravelRequestEditList",
      },
      children: [
        {
          name: "detailTravelRequestEditList",
          path: "/app/travel-request/edit-list/:id/detail",
          component: () => import("./detail-view.vue"),
          meta: {
            listName: "travelRequestEditList",
            showRight: true,
            appName: "travelRequestEditList",
            detail: "detailTravelRequestEditList",
          },
          props: {
            onlyShowTravelRequestEditDetail: true,
          },
        },
      ],
    },
    {
      name: "reportTravelRequest",
      path: "/app/travel-request/report",
      component: () =>
        import("./childApp/reportTravelRequest/report-travel-request.vue"),
      meta: {
        appName: "reportTravelRequest",
      },
    },
  ],
};
